"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtMinus = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtMinus = function SvgBtMinus(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("line", {
    x1: 21.5,
    y1: 14,
    x2: 6.5,
    y2: 14,
    stroke: "currentColor",
    strokeLinecap: "round"
  }));
};

exports.SvgBtMinus = SvgBtMinus;